import { render, staticRenderFns } from "./whatNft.vue?vue&type=template&id=68ee436f&scoped=true"
import script from "./whatNft.vue?vue&type=script&lang=js"
export * from "./whatNft.vue?vue&type=script&lang=js"
import style0 from "./whatNft.vue?vue&type=style&index=0&id=68ee436f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee436f",
  null
  
)

export default component.exports